import { useMutation, useQueryClient } from '@tanstack/react-query';
import { assignDID } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useAssignDID({
  onSuccessFn = () => null,
  onErrorFn = () => null,
}) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: assignDID,
    mutationKey: ['assignDID'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        onErrorFn();
        return toastEmitter('error', responseData?.error?.message);
      }
      onSuccessFn();
      queryclient.invalidateQueries(['getMemberListing']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
